(() => {
  const menuToggleBtnExpr = '.menu-toggle-btn';
  const menuListToggleBtnExpr = '.menu-item-has-children-link';

  const init = () => {
    $('body')
      .on('click', menuToggleBtnExpr, menuToggle)
      .on('click', menuListToggleBtnExpr, menuListToggle);
  }

  const menuToggle = () => {
    if($('.menu-modal').hasClass('active')){
      $('.menu-modal').removeClass('active');
      setTimeout(function(){
          $('.menu-modal').removeClass('show-modal');
      },300);
    } else {
      $('.menu-modal').addClass('show-modal');
      setTimeout(function(){
          $('.menu-modal').addClass('active');
      },300);
    }
    return false
  }

  const menuListToggle = (e) => {
    var element = $(e.currentTarget);
    parent = element.parents('.menu-item-has-children');
    parent.toggleClass('active');
    parent.find('.sub-menu').stop().slideToggle(100);
    return true
  }
  $(init)
})();
